const readWindowEnv = () => {
	if (typeof window === 'undefined') return undefined;
	return window.env;
};

const getRuntimeEnvValue = (windowEnvValue: string | undefined, viteEnvValue: string | undefined) => {
	return windowEnvValue ?? viteEnvValue ?? '';
};

/** Read `window.env` on each access so values set by `/env.js` after module load are visible. */
export const runtimeEnv = {
	get apiBaseUrl() {
		return getRuntimeEnvValue(readWindowEnv()?.VITE_API_BASE_URL, import.meta.env.VITE_API_BASE_URL)
	},
	get webBaseUrl() {
		return getRuntimeEnvValue(
			readWindowEnv()?.VITE_PUBLIC_WEB_BASE_URL,
			import.meta.env.VITE_PUBLIC_WEB_BASE_URL,
		)
	},
}
